import React, { useState } from 'react';

function Pinpad(props) {
  const [pin, setPin] = useState("");
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState("");
  
  const padTouch = (e) => setPin(pin + e.target.value)

  const padClear = () => setPin("")

  const padEnter = () => {
    var init = { method: 'POST',
               mode: 'cors',
               cache: 'default',
               body: JSON.stringify({
                 "email": JSON.parse(localStorage.getItem("email")),
                 "mission": props.mission,
                 "stage": props.stage,
                 "code": pin
            }) };
    console.log("sent: " + pin)
    fetch("https://escape.funatmdf.click/validate", init)
      .then(res => res.json())
      .then(
        (result) => {
          setStatus(result.status)
          setMessage(result.message)
          console.log("result: " + JSON.stringify(result.status))
        },
        (error) => {
          console.log("error: " + error)
        }
      )
    
  }

  return status === "success"? (
   <div id="pinpad">
     <form>
       <h3>Congratulation!</h3>
       <h4>{message}</h4>
     </form>
   </div> 
  )
  :(
    <div id="pinpad">
        <form data-bitwarden-watching="1">
          {status === "wrong_code" && <h3>Wrong code, try again!</h3>}
          <input type="text" id="password" readOnly value={pin} className="pinCode"/><br/>
          <input type="button" value="1" onClick={padTouch} className="pinButton calc"/>
          <input type="button" value="2" onClick={padTouch} className="pinButton calc"/>
          <input type="button" value="3" onClick={padTouch} className="pinButton calc"/><br/>
          <input type="button" value="4" onClick={padTouch} className="pinButton calc"/>
          <input type="button" value="5" onClick={padTouch} className="pinButton calc"/>
          <input type="button" value="6" onClick={padTouch} className="pinButton calc"/><br/>
          <input type="button" value="7" onClick={padTouch} className="pinButton calc"/>
          <input type="button" value="8" onClick={padTouch} className="pinButton calc"/>
          <input type="button" value="9" onClick={padTouch} className="pinButton calc"/><br/>
          <input type="button" value="clear" onClick={() => padClear()} className="pinButton clear"/>
          <input type="button" value="0" onClick={padTouch} className="pinButton calc"/>
          <input type="button" value="enter" onClick={() => padEnter()} className="pinButton enter"/>
        </form>
    </div>
  );
}

export default Pinpad;